app.factory('userService', [ '$rootScope', '$http','$window', '$route','$location' ,'$cookies',
function($rootScope,$http, $window, $route, $location, $cookies) {
    return {
        requestPasswordReset: function(email){
            return $http.post("/password-reset/email", {"email": email}, {ignoreAuth: true})
            .then(res => {
                alert.success("Email sent! Please check your inbox");
                return res;
            }, errorHandler)
        },
        get : function(id) {
            return $http
            .get('api/users/' + id)
            .then(res => {
                return res.data;
            }, errorHandler);
        },

        add: function(user){
            return $http
            .post('api/users/add', user)
            .then(res => {
                let user_id = res.data["id"]
                alert.success("New user saved successfully!");
                $location.path("/users/" + user_id);
                return res.data;
            }, errorHandler);
        },

        find: function(filter){
            return $http
            .post('api/users/', filter)
            .then(res => {
                return res.data;
            }, errorHandler);
        },

        update: function(user){
            return $http
            .put('api/users/', user)
            .then(res => {
                alert.success("User updated successfully!")

                return res.data;
            }, errorHandler);
        },

        remove: function(id){
            if(confirm("Are you sure?")){
                return $http
                .delete('api/users/' + id)
                .then(() => {
                    alert.success("User deleted successfully!")
                    $location.path("/users");
                }, errorHandler);
            }
        },

        login: function(credentials){
            return $http.post('/api/authenticate', credentials)
            .then(res => {
                let token = res.data.token
                let user = {
                    "nome": res.data["nome"],
                    "empresa_nome": res.data["empresa_nome"],
                    "email": res.data["email"]
                }
                $cookies.put('token', token, {"expires": moment().add(1, 'days').toDate()})

                alert.success("You are now logged in");

                $rootScope.ON_LOGIN = false;


                $rootScope.user = user;
                $rootScope.$emit("USER_LOGGED", user);
                $route.reload()
                return user; //TODO proper return
            },
            (err) => {
                $rootScope.ON_LOGIN = false;
                // $window.sessionStorage.removeItem('token');
                $cookies.remove('token');
                errorHandler(err)
            })
        },

        addRole(role, user){
            if(_.isEmpty(user.roles)) user.roles = [];

            if(_.find(user.roles, (ur) => {return ur.id === role["id"]})){
                _.remove(user.roles, (ur) => {return ur.id === role["id"]})
            }else{
                user.roles.push(role);
            }

            return user;
        },

        checkUserRoles: function(roles, user){
            _.forEach(roles, (role)=> {
                if(!_.isEmpty(_.find(user.roles, (ur) => {return ur["id"] === role["id"]}))){
                    role.checked = true;
                }else{
                    role.checked = false;
                }
            })
            return roles;
        }
    };
} ]);
